import React from 'react';
import { Card } from 'react-bootstrap';
import { Link } from 'react-router-dom';

const UpdateOzimoCard = () => {
  return (
    <Card className="shadow-sm mb-4">
      <Card.Body>
        <Card.Title>Update Oximo Price</Card.Title>
        <Card.Text>
          <Link to="/updateoximo" style={{ textDecoration: 'none', fontWeight: 'bold', color: '#007bff' }}>
            Update Oximo Price →
          </Link>
        </Card.Text>
      </Card.Body>
    </Card>
  );
};

export default UpdateOzimoCard;
